import { CreateBookingInterestResponse, UserBookingInterestsResponse, entityId, BookingInterestsAccessibilityRequestResponse, BulkCsvAddBookingInterestsResponse } from '../models/types';
import { fetchWithAuth, defaultFetch } from '../utils/auth';
import { BookingInterestInfoResponse } from "../models/types";
import { AllocationBookingInterestInterface, BulkCsvAddBookingInterestsInterface, UserBookingInterest } from '../models/BookingInterest';

export const readUserBookingInterests = async (): Promise<UserBookingInterestsResponse> => {
  try {
    const fetchUrl = `/api/backend/v1/bookingInterests`;
    const res = await fetchWithAuth(fetchUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      throw new Error("Server not returned a valid response");
    }
    const resJson = await res.json();
    return new UserBookingInterestsResponse({
      data: resJson?.bookingInterests
        ? resJson.bookingInterests.map(
          (item: any) => new UserBookingInterest(item)
        )
        : null,
    });
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to load ticket";
    }
    return new UserBookingInterestsResponse({ error: message });
  }
};

export const readBookingInterestsWithAccessibilityRequests = async (showId: number): Promise<BookingInterestsAccessibilityRequestResponse> => {
  try {
    const fetchUrl = `/api/backend/v1/bookingInterests/accessibility-requests/${showId}`;
    const res = await fetchWithAuth(fetchUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      throw new Error("Server not returned a valid response");
    }
    const resJson = await res.json();
    return new BookingInterestsAccessibilityRequestResponse({ data: resJson?.bookingInterests });
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to load booking interests";
    }
    return new BookingInterestsAccessibilityRequestResponse({ error: message });
  }
};

export const createBookingInterest = async (bookingInterest: any, magicLink?: string): Promise<CreateBookingInterestResponse> => {
  let response;
  let url = `/api/backend/v1/bookinginterests`
  if (magicLink) url += `?priority=${magicLink}`
  let message;
  try {
    const body: string = JSON.stringify(bookingInterest);
    const res = await fetchWithAuth(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.errors.message);
    }
    response = await res.json()

  } catch (error) {
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = 'Unable to create session';
    }
  }
  return new CreateBookingInterestResponse({ data: response, error: message })
};

export const createAllocationBookingInterest = async (bookingInterest: any): Promise<CreateBookingInterestResponse> => {
  let bookingInterestId: entityId | null = null;
  let response;
  let message;
  try {
    const body: string = JSON.stringify(bookingInterest);
    const res = await fetchWithAuth(`/api/backend/v1/bookinginterests/allocated`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.errors.message);
    }
    response = await res.json()

  } catch (error) {
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = 'Unable to create session';
    }
  }
  return new CreateBookingInterestResponse({ data: response, error: message })
};

export const updateGuestsBookingInterest = async (bookingInterest: any): Promise<CreateBookingInterestResponse> => {
  let response;
  let url = `/api/backend/v1/bookinginterests/guests`
  let message;
  try {
    const body: string = JSON.stringify(bookingInterest);
    const res = await fetchWithAuth(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.errors.message);
    }
    response = await res.json()

  } catch (error) {
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = 'Unable to update guests';
    }
  }
  return new CreateBookingInterestResponse({ data: response, error: message })
};

export const confirmBookingInterest = async (token: string): Promise<any> => {
  try {
    const res = await defaultFetch(`/api/backend/v1/bookinginterests/confirm-bookinginterest/${token}`, {
      method: "POST",
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.error);
    }
    const response = await res.json();
    return {
      response,
    };
  } catch (error) {
    return { error };
  }
};

export const readBookingInterestRelatedInfo = async (id: string): Promise<BookingInterestInfoResponse> => {
  try {
    const res = await fetchWithAuth(`/api/backend/v1/bookinginterests/bookinginterest-related-information/${id}`)
    if (res.status >= 400 && res.status < 600) {
      throw new Error("Server not returned a valid response")
    }
    const resJson = await res.json();
    return new BookingInterestInfoResponse({ data: resJson });
  } catch (error) {
    let message
    if (error instanceof Error) {
      message = error.message
    } else {
      message = 'Unable to load booking interests'
    }
    return new BookingInterestInfoResponse({ error: message })
  }
};

export const deleteBookingInterestTicket = async (bookingInterestId: number): Promise<any> => {
  try {
    const res = await fetchWithAuth(`/api/backend/v1/bookinginterests/${bookingInterestId}`, {
      method: 'DELETE',
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
  } catch (error) {
    let message = 'Unable to delete booking interest ticket';

    if (error instanceof Error) {
      message = error.message;
    }

    return { error: message };
  }
}

export const editBookingInterest = async (bookingInterest: AllocationBookingInterestInterface): Promise<any> => {
  try {
    const body: string = JSON.stringify(bookingInterest);
    const res = await fetchWithAuth(`/api/backend/v1/bookingInterests`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    return res
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = 'Unable to edit booking interest ticket invite';
    }
    return { error: message };
  }
};

export const CsvBulkAdd = async (bulkCsvRequest: BulkCsvAddBookingInterestsInterface): Promise<BulkCsvAddBookingInterestsResponse> => {
  let response;
  let message;
  try {
    const fileKeys = ['name', 'type']
    const body = new FormData()

    body.append(`SessionId`, bulkCsvRequest.sessionId.toString())
    body.append(`AllocationId`, bulkCsvRequest.allocationId.toString())

    if (bulkCsvRequest.bookingInterestCsv != null) {
      body.append(`BookingInterestCsv`, bulkCsvRequest.bookingInterestCsv)
      for (let csvKey of fileKeys) {
        body.append(`BookingInterestCsv.${csvKey}`, bulkCsvRequest.bookingInterestCsv[csvKey])
      }
    }

    const res = await fetchWithAuth(`/api/backend/v1/bookinginterests/bulkadd`, {
      method: 'POST',
      body
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.errors.message);
    }
    response = await res.json()

  } catch (error) {
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = 'Unable to bulk add';
    }
  }

  return new BulkCsvAddBookingInterestsResponse({ data: response, error: message })
};